import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/common/Reveal";

// Homepage Insights teaser — renders only when approved (published) content exists.
export const InsightsTeaser = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/api/insights").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section className="bg-white py-16 lg:py-24" data-testid="home-insights">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <p className="eyebrow mb-3">Insights</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-ink-heading">
              Perspectives on international trade
            </h2>
          </div>
          <Link to="/insights" data-testid="home-insights-all" className="inline-flex items-center gap-2 text-sm font-semibold text-azeka-navy hover:text-azeka-teal transition-colors">
            All insights <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {items.slice(0, 3).map((it, idx) => (
            <Reveal key={it.slug} delay={idx * 0.08}>
              <Link to={`/insights/${it.slug}`} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-surface-base transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-azeka-navy/10">
                {it.cover_image ? (
                  <div className="h-44 overflow-hidden">
                    <img src={it.cover_image} loading="lazy" decoding="async" alt={it.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                ) : null}
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="text-base font-semibold text-ink-heading">{it.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-muted">{it.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
